import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AssignCoursesList from "../components/EnRolledCourseList";

const EnRolledCourseList = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Enrolled Courses  </h5><Breadcrumb title="Enrolled Courses" /></div>

        {/* AssignRoleLayer */}
        <AssignCoursesList />

    </>
  );
};

export default EnRolledCourseList;
